const iconList = [   // 阿里云icon
  'iconquanxian',
  'iconxitong',
  'iconjichuxinxiguanli',
  'iconhangyemuluguanli',
  'iconzcpt-zhishikuguanli',
  'iconpeizhihechajieguobaobiao',
  'iconcaigou',
  'iconxiaoshou',
  'iconjiancha',
  'iconzongheshuju',
  'iconqushizushutubiao',
  'iconjigou'
]
const key = 'local_verification'   // 存储本地key前缀
const passList = [
  '/manager/login',
  '/manager/index',
]

const IMG_PREV = ''

const errorCode = {
  '000': '操作太频繁，请勿重复请求',
  '401': '当前操作没有权限',
  '403': '当前操作没有权限',
  '404': '资源不存在',
  '417': '未绑定登录账号，请使用密码登录后绑定',
  '423': '演示环境不能操作，如需了解联系冷冷',
  '426': '用户名不存在或密码错误',
  '428': '验证码错误,请重新输入',
  '429': '请求过频繁',
  '479': '演示环境，没有权限操作',
  'default': '系统未知错误,请反馈给管理员'
}

const dict = {
  dictType: [
    {
      label: '系统类',
      value: '1'
    },
    {
      label: '业务类',
      value: '0'
    }
  ]
}

export {
  iconList,
  key,
  passList,
  errorCode,
  dict,
  IMG_PREV
}



// WEBPACK FOOTER //
// ./src/utils/global.js